import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@hungryroot/component-error-boundary';
import { fullPageRedirect } from '@hungryroot/environment';
import {
  Breadcrumb,
  FunnelHeader,
  useFunnelRedirects,
} from '@hungryroot/funnel';
import { Cyo, CyoPage } from '@hungryroot/page-cyo';
import { queryClient } from '@hungryroot/rest';
import { MY_HUNGRYROOT_ROUTE } from '@hungryroot/routes';
import { Utm } from '@hungryroot/segment';
import { renderApp } from '../../frontend/react/src/utils/utils';

function onSaveAndExitClick() {
  fullPageRedirect(MY_HUNGRYROOT_ROUTE);
}

const CyoPageWrapper = () => {
  const funnelRedirects = useFunnelRedirects();

  if (!funnelRedirects) {
    return null;
  }

  const { afterCyo, beforeCyo } = funnelRedirects;

  return (
    <>
      <Cyo
        header={
          <FunnelHeader
            saveAndExitButtonText="Save and exit"
            onSaveAndExitClick={onSaveAndExitClick}
          >
            <Breadcrumb selected="Claim Offer" />
          </FunnelHeader>
        }
        showPromo={true}
      />
      <CyoPage
        backCyoPath={beforeCyo}
        onCustomerUpdated={() => {
          fullPageRedirect(afterCyo);
        }}
        selectCyoPath={afterCyo}
      />
    </>
  );
};

if (document.getElementById('limited-time-page') !== null) {
  renderApp(
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Utm search={window.location.search} />
        <CyoPageWrapper />
      </QueryClientProvider>
    </ErrorBoundary>,
    'container'
  );
}
